import { call, put, takeLatest } from 'redux-saga/effects'
import get_ from 'lodash/get'
import { generalDoFailure } from '../../../util/fetchFailure'
import { privateFetch } from '../../../fetch'

import { API_URL_PATH_CUSTOMERS } from '../../../../../constants'

import {
  saveKegCollectionBookingVenues,
  fetchKegCollectionBookingVenuesRequest,
  fetchKegCollectionBookingVenuesSuccess,
  fetchKegCollectionBookingVenuesFailure,
} from './utils'

import { FETCH_KEG_COLLECTION_BOOKING_VENUES } from '../../../../actions/actionTypes'

function* fetchVenuesWorker(action) {
  if (!action) return

  const { customerParams } = action.payload || {}

  yield put(fetchKegCollectionBookingVenuesRequest())

  try {
    const response = yield call(privateFetch, {
      path: API_URL_PATH_CUSTOMERS,
      params: customerParams,
    })

    const venues = response.data || []
    yield call(doSuccessVenues, venues)
  } catch (error) {
    if (get_(error, 'response.status') === 404) {
      // No venues found - treat as empty list
      yield call(doSuccessVenues, [])
      return
    }
    yield call(doFailureVenues, error)
  }
}

export default [[takeLatest, FETCH_KEG_COLLECTION_BOOKING_VENUES, fetchVenuesWorker]]

function* doSuccessVenues(venues) {
  yield put(saveKegCollectionBookingVenues(venues))
  yield put(fetchKegCollectionBookingVenuesSuccess())
}

function* doFailureVenues(error) {
  yield call(generalDoFailure, { error, action: fetchKegCollectionBookingVenuesFailure(error) })
}
